module.exports = __webpack_public_path__ + "img/40.2ed44258.png";